import api from '@utils/api';

export const fetchTime = () => {
  return api.get('v2/time');
};
